import { GET_COINSELLER_UNIQUEID, GET_USER, HOST_DISABLE, REMOVE_HOST } from "./types";

const initialState = {
  user: [],

  totalUser: 0,
  userId: [],
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_USER:
      return {
        ...state,
        user: action.payload.agencyWiseHost,
        totalUser: action.payload.total,
      };

    case GET_COINSELLER_UNIQUEID:
      return {
        ...state,
        userId: action.payload,
      };

    case HOST_DISABLE:
      return {
        ...state,
        user: state?.user.map((data) =>
          data._id === action.payload.id ? action.payload.data : data
        ),
        hostProfile: action.payload.data,
      };

    case REMOVE_HOST:
      return {
        ...state,
        user: (state.user || []).filter(
          (data) => String(data._id) !== String(action.payload)
        ),
        totalUser: Math.max(0, (state.totalUser || 0) - 1),
      };

    default:
      return state;
  }
};

export default userReducer;
